<template>
  <v-container>
  <v-layout row wrap justify-center>
    <v-flex sm8 xs12>
    <v-card hover>
      <v-card-title class="headline">
        The ANZ Streamer Directory is a manually curated index of Australian & New Zealand Twitch streamers and run by volunteers from the community.
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="title">
        If you would like a channel added to our index submit the channel name below.
      </v-card-text>
      <v-card-text class="subheading">
        They must be Australian or New Zealand based and mention this in their description, a stream status or linked social media account.
      </v-card-text>
    </v-card>
  </v-flex>
  </v-layout>
  <v-layout row wrap class='mt-5' justify-center>
    <v-card class='pa-4 text-xs-center' hover>
      <span class="headline">Submit Channel</span>
      <v-divider></v-divider>
      <v-form name='add-channel' id='add-channel' ref='submitChannel' @submit='submitChannel' netlify class='pt-3'>
        <v-text-field v-model="channelName" type='text' name='channel-name' id='channel-name' label='Channel Name' prefix='twitch.tv/' :rules='channelNameRules' @input="getChannel" validate-on-blur clearable></v-text-field>
        <v-textarea v-model="comments" name='comment' id='comment' label='Comments' multiline></v-textarea>
        <vue-recaptcha class="ma-1" sitekey='6Le5Mp8UAAAAAGvSCIJ7hxOdPhk7KeoKv9-nfnpp' @expired="onExpired" @verify='onVerify'></vue-recaptcha>
        <v-btn class="ma-1" color='accent' type='submit' :disabled='!verify'>Submit</v-btn>
      </v-form>
      {{this.response}}
    </v-card>
  </v-layout>
  </v-container>
</template>

<script>
import TwitchWrapper from '@/TwitchWrapper'
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'About',
  components: {VueRecaptcha},
  data () {
    return {
      response: '',
      isLoaded: false,
      channels: [],
      channelName: '',
      channel: 0,
      comments: '',
      verify: false,
      twitch: new TwitchWrapper(this.$root.$data.clientId),
      channelNameRules: [
        v => this.channel != 0 || 'Channel must exist',
        v => !this.channels.includes(this.channel) || 'Already Following Channel',
        v => !!v || 'Channel Name is required',
      ],
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      this.twitch.GetFile("ids.txt").then(ids => {
          this.channels = ids
          this.isLoaded = true
      })
    },
    getChannel (e) {
      this.channel = 0

      this.twitch.GetChannelId(e.toString()).then(c => {
        if(c._total > 0) {
          this.channel = c.users[0]._id
        }

        

      })
    },
    onExpired: function () {
      this.verify = false
    },
    onVerify: function (response) {
      this.verify = response
    },
    submitChannel: function(e) {
      e.preventDefault()
      if(this.$refs.submitChannel.validate()) {
        let formData = `form-name=add-channel&channel-name=${encodeURIComponent(this.channelName)}&comments=${encodeURIComponent(this.comments)}&g-recaptcha-response=${encodeURIComponent(this.verify)}&channel-url=${encodeURIComponent("https://twitch.tv/" + this.channelName)}`
        fetch('/about', {
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
          body: formData,
        }).then(r => {
          if(r.status === 200) {
            return "Thank you for your submission!"
          }
          else {
           return "Unable to submit, try again later."
          }
        }).then(r => {
          this.response = r
        }).catch(e => {
          let errorObj = JSON.parse(e.message)
          this.$emit('errorUpdate', errorObj.message)
        })
      }
    },
  }
}

</script>